export var SignalStatus;
(function (SignalStatus) {
    SignalStatus["NOT_READY"] = "not ready";
    SignalStatus["READY"] = "ready";
})(SignalStatus || (SignalStatus = {}));
